<script>
	import Modal from 'svelte-simple-modal';
	import Home from "./components/Home.svelte";
	import Login from "./components/Login.svelte";
	import { key } from "./store";

	let storedKey;
	key.subscribe((newValue) => storedKey = newValue);

</script>

<main class="app">
	<Modal>
		{#if !storedKey}
			<Login />
		{:else}
			<Home />
		{/if}
	</Modal>
</main>

<style>
	.app {
		height: 100vh;
		width: 100vw;
	}
</style>